import { inject, Injectable } from '@angular/core';
import { IdentityApiService } from '@identity/identity-api.service';
import { IdentityClientService } from '@identity/identity-client.service';
import { IdentityConfigurationService } from '@identity/identity-configuration.service';
import { IdentityConstants } from '@identity/identity-constants.service';
import { IdentityStorageService } from '@identity/identity-storage.service';
import { IdentityUserService } from '@identity/identity-user.service';
import { IdentityProvider } from '@identity/identity.provider';

@Injectable({
    providedIn: 'root'
})


export class IdentityServicesService {
    public identityProvider = inject(IdentityProvider);
    public identityApiService = inject(IdentityApiService);
    public identityConstants = inject(IdentityConstants);
    public identityClient = inject(IdentityClientService);
    public identityStorage = inject(IdentityStorageService);
    public identityConfigurationService = inject(IdentityConfigurationService);

    constructor() { }
}

